import * as styles from './LoadingCircle.css';
import { LoadingCircleIcon } from '@/assets/icons';

const LoadingCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return <LoadingCircleIcon className={styles.container} {...props} />;
};

export default LoadingCircle;
